import Image from "next/image";
import Link from "next/link";
import { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
  isTextLeft?: boolean;
}

export const LayoutLoginTemplate: FC<Props> = ({ children, isTextLeft }) => {
  return (
    <>
      <header
        className={`bg-white drop-shadow-sm ${
          isTextLeft ? "md:drop-shadow-none" : ""
        }`}
      >
        <div
          className={`flex justify-center items-center px-2 h-[50px] md:px-4 ${
            isTextLeft ? "md:justify-start" : ""
          }`}
        >
          <Link href="/login">

            <Image
              src="/user/logo.svg"
              width="136"
              height="26"
              alt="Yoyacoo"
              className="block"
            />

          </Link>
        </div>
      </header>
      <div className="px-4 pb-10 bg-white md:pb-16">{children}</div>
    </>
  );
};
